// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"eed230b7","453":"0f5103f8","796":"5a22880d"}[chunkId] + ".chunk.js";
};